import Angie from './Angie.svg';
import Ed from './Ed.svg';
import More from './More.svg';
import Norah from './Norah.svg';

export { default as Background } from './Background.svg';
export const DEFAULT_USERS = [Norah, Angie, Ed, More].map((src) => ({
	name: '',
	src,
}));
